module.exports = __webpack_public_path__ + "static/media/bd-map.d1cccb94.png";